/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S13_P2_PreInputs */

const tr_iade_iptal_s13_p2_pre = /** @type {(inputs: Iade_Iptal_S13_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici sıfatını haiz Abone, parasal sınırlar dahilinde Tüketici Hakem Heyeti'ne, sınırların üzerinde Tüketici Mahkemeleri'ne başvurabilir. Ticaret Bakanlığı'nın`)
};

const en_iade_iptal_s13_p2_pre = /** @type {(inputs: Iade_Iptal_S13_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Subscriber with consumer status may apply to the Tüketici Hakem Heyeti within the monetary limits and to the Tüketici Mahkemeleri above those limits. An application may also be made through the`)
};

const de_iade_iptal_s13_p2_pre = /** @type {(inputs: Iade_Iptal_S13_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Abonnent mit Verbrauchereigenschaft kann sich innerhalb der Wertgrenzen an die Tüketici Hakem Heyeti und oberhalb der Grenzen an die Tüketici Mahkemeleri wenden. Ein Antrag kann auch über die Plattform`)
};

const ru_iade_iptal_s13_p2_pre = /** @type {(inputs: Iade_Iptal_S13_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонент, имеющий статус потребителя, может обратиться в Tüketici Hakem Heyeti в пределах денежных лимитов и в Tüketici Mahkemeleri сверх этих лимитов. Обращение также может быть подано через принадлежащую Ticaret Bakanlığı платформу`)
};

/**
* | output |
* | --- |
* | "A Subscriber with consumer status may apply to the Tüketici Hakem Heyeti within the monetary limits and to the Tüketici Mahkemeleri above those limits. An ap..." |
*
* @param {Iade_Iptal_S13_P2_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s13_p2_pre = /** @type {((inputs?: Iade_Iptal_S13_P2_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S13_P2_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s13_p2_pre(inputs)
	if (locale === "de") return de_iade_iptal_s13_p2_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s13_p2_pre(inputs)
	return tr_iade_iptal_s13_p2_pre(inputs)
});